//region :: Imports ::
import {ReactElement} from 'react';
import MComponent from '../Component';
import MButton from './Button';
import {MBoolean} from './Control';
import {CopyIconName} from '../../Icons';
import TooltipOptions from 'primereact/tooltip/tooltipoptions';

//endregion

/** */
type Props = {
    disabled?: MBoolean;
    onClick?: () => Promise<void>;
}

/** */
type State = {
    tooltipText: string;
}

/** */
class MCopyButton extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.button_onClick = this.button_onClick.bind(this);
        this.buttonTooltip_onHide = this.buttonTooltip_onHide.bind(this);

    }

    /** */
    private initializeState(): void {
        this.state = {tooltipText: 'Copy to clipboard'};
    }

    /** */
    private async button_onClick(): Promise<void> {

        if(this.props.onClick === undefined) {
            return;
        }

        await this.props.onClick();
        this.safeSetState((draft: State) => draft.tooltipText = 'Copied');

    }

    /** */
    private buttonTooltip_onHide(): void {
        this.safeSetState((draft: State) => draft.tooltipText = 'Copy to clipboard');
    }

    /** */
    public render(): ReactElement {

        const disabled = this.props.disabled === undefined ? false : this.props.disabled;
        const toolTipOptions: TooltipOptions = {position: 'right', hideDelay: 250, event: 'hover', onHide: this.buttonTooltip_onHide};

        return (
            <MButton icon={CopyIconName}
                     iconOnly={true}
                     tooltip={this.state.tooltipText}
                     tooltipOptions={toolTipOptions}
                     disabled={disabled}
                     onClick={this.button_onClick}/>
        );

    }

}

export default MCopyButton;
